const getRouterOrOutletProps = <T extends Partial<Record<string, any>>>(
  passedProps: T,
  outletProps: T
): Required<T> =>
  Object.fromEntries(
    Object.entries({ ...passedProps, ...outletProps }).map(([key, _]) => [
      key,
      passedProps[key] ?? outletProps[key]!
    ])
  ) as Required<T>;

export { getRouterOrOutletProps };
